import React from "react";
import { Button } from "@amzn/stencil-react-components/button";
import { Col } from "@amzn/stencil-react-components/layout";
import { Link } from "@amzn/stencil-react-components/link";
import { useParams } from "react-router-dom";
import { Hr } from "@amzn/stencil-react-components/layout";

interface Props {
  buttonMessage: string;
  documentType: string;
}

export const DocumentUploadButton = ({
  buttonMessage,
  documentType,
}: Props) => {
  const { requisitionId, applicationId } = useParams<{
    applicationId: string;
    requisitionId: string;
  }>();

  return (
    <Col
      gridGap={16}
      display={"flex"}
      height={"60px"}
      alignItems={"center"}
      justifyContent={"center"}
    >
      <Link
        style={{ width: "100%", display: "flex" }}
        href={`/checklist/tasks/document/${requisitionId}/${applicationId}/${documentType}/false`}
        textDecoration={"none"}
      >
        <Button style={{ width: "100%" }}> {buttonMessage}</Button>
      </Link>
      <Hr />
    </Col>
  );
};
